var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"i-map",style:({height:_vm.height+'px'}),attrs:{"id":'map_2gis_'+_vm.mapId}})}
var staticRenderFns = []

export { render, staticRenderFns }